module.exports = __webpack_public_path__ + "static/media/bug.b3e48329.svg";